'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var prosemirrorCommands = require('prosemirror-commands');
var keymap = _interopDefault(require('../keymap/index.js'));
var index_js = require('../utils/index.js');
var index_js$1 = require('../cursor/index.js');
var prosemirrorTransform = require('prosemirror-transform');
var prosemirrorModel = require('prosemirror-model');
var prosemirrorState = require('prosemirror-state');
var index_ts = require('../consts/index.js');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty = _defineProperty;

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      defineProperty(target, key, source[key]);
    });
  }

  return target;
}

var objectSpread = _objectSpread;

function markApplies(doc, ranges, type) {
  for (let i = 0; i < ranges.length; i++) {
    const {
      $from,
      $to
    } = ranges[i];
    let can = $from.depth === 0 ? doc.type.allowsMarkType(type) : false;
    doc.nodesBetween($from.pos, $to.pos, node => {
      if (node.inlineContent && node.type.allowsMarkType(type)) can = true;
      return !can;
    });
    if (can) return true;
  }

  return false;
} // 设置文本格式


function setTextBlockType(nodeType, attrs) {
  return function (state, dispatch, view) {
    const {
      tr,
      selection,
      schema
    } = state;
    const {
      paragraph,
      heading,
      list_item,
      task_item,
      text
    } = schema.nodes;
    const {
      font
    } = schema.marks;
    let transaction; // 处于 CellSelection 时可能有多个 range

    selection.ranges.forEach(range => {
      const from = range.$from.pos;
      const to = range.$to.pos;
      tr.doc.nodesBetween(from, to, (node, pos, parent) => {
        //设置标题时，移除文字上设置的字体
        if (node.type === text) {
          tr.removeMark(pos, pos + node.text.length, font);
        }

        if (node.type === paragraph || node.type === heading) {
          transaction = tr.setNodeMarkup(pos, nodeType, objectSpread({}, node.attrs, attrs));

          if ((parent.type === list_item || parent.type === task_item) && tr.doc.nodeAt(pos - 1)) {
            transaction = tr.setNodeMarkup(pos - 1, null, objectSpread({}, parent.attrs, {
              level: attrs && attrs.level
            }));
          }
        }
      });
    });
    if (!transaction) return false;
    dispatch(transaction.scrollIntoView());
    view.focus();
    return true;
  };
}
function setIndent(type) {
  return function (state, dispatch, view) {
    const attrsGetter = attrs => objectSpread({}, attrs, {
      indent: attrs.indent + (type === 'more' ? 1 : -1)
    });

    try {
      const {
        selection,
        tr,
        schema
      } = state;
      const {
        table,
        list_item,
        task_item
      } = schema.nodes;
      const itemTypes = [list_item, task_item];
      let transaction; // 处于 CellSelection 时可能有多个 range

      selection.ranges.forEach(range => {
        const from = range.$from.pos;
        const to = range.$to.pos;
        let blockStart = 0;
        let blockEnd = 0;
        tr.doc.nodesBetween(from, to, (node, pos) => {
          if (pos > blockStart && pos < blockEnd) return;

          if (itemTypes.includes(node.type)) {
            if (pos < from || pos > to) return;
            blockStart = pos;
            blockEnd = pos + node.nodeSize;
          }

          if (node.type === table) {
            return false;
          }

          const attrs = node.attrs;

          if (attrs.indent !== undefined && (type !== 'less' || attrs.indent > 0)) {
            const newAttrs = attrsGetter(attrs);
            transaction = tr.setNodeMarkup(pos, null, newAttrs);
          }
        });
      });
      if (!transaction) return false;

      if (dispatch) {
        dispatch(transaction);
        view.focus();
      }

      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  };
} // (align: 'left' | 'center' | 'right') -> Command

function setAlign(align) {
  return function (state, dispatch, view) {
    const {
      selection,
      tr
    } = state;
    let transaction; // 处于 CellSelection 时可能有多个 range

    selection.ranges.forEach(range => {
      const from = range.$from.pos;
      const to = range.$to.pos;
      tr.doc.nodesBetween(from, to, (node, pos) => {
        if (!node.type.spec.alignBlock) return;

        const newAttrs = objectSpread({}, node.attrs, {
          align
        });

        try {
          transaction = tr.setNodeMarkup(pos, null, newAttrs);
        } catch (e) {}
      });
    }); // 虚拟光标前后的块

    if (selection instanceof index_js$1.GapCursor) {
      const {
        $from,
        dom
      } = selection;
      const {
        nodeBefore,
        nodeAfter,
        pos
      } = $from;
      if (!dom) return false;
      let domPos;

      try {
        domPos = view.docView.posFromDOM(dom);
      } catch (error) {
        return false;
      }

      if (nodeAfter && nodeAfter.type.spec.alignBlock && nodeAfter.type.isAtom && domPos === pos) {
        const newAttrs = objectSpread({}, nodeAfter.attrs, {
          align
        });

        transaction = tr.setNodeMarkup(pos, null, newAttrs);
      }

      if (nodeBefore && nodeBefore.type.spec.alignBlock && nodeBefore.type.isAtom && domPos < pos) {
        const newAttrs = objectSpread({}, nodeBefore.attrs, {
          align
        });

        transaction = tr.setNodeMarkup(pos - 1, null, newAttrs);
      }
    }

    if (!transaction) return false;

    if (dispatch) {
      dispatch(transaction);
      view.focus();
    }

    return true;
  };
} // 设置文本格式

function toggleMark(markType, attrs) {
  return function (state, dispatch, view) {
    const {
      tr,
      selection,
      schema
    } = state;
    const {
      empty,
      $cursor,
      ranges
    } = selection;

    if (empty && !$cursor || !markApplies(state.doc, ranges, markType)) {
      view.focus();
      return false;
    }

    if (selection instanceof prosemirrorState.NodeSelection) {
      return false;
    }

    if (dispatch) {
      if ($cursor) {
        if (markType.isInSet(state.storedMarks || $cursor.marks())) {
          dispatch(state.tr.removeStoredMark(markType));
        } else {
          dispatch(tr.addStoredMark(markType.create(attrs)));
        }
      } else {
        let has = false;

        for (let i = 0; !has && i < ranges.length; i++) {
          const {
            $from,
            $to
          } = ranges[i];
          has = state.doc.rangeHasMark($from.pos, $to.pos, markType);
        }

        const isCellSelection = selection.constructor.name === 'CellSelection';
        let prePos = null;
        let insertTextCount = 0;

        for (let i = 0; i < ranges.length; i++) {
          const {
            $from,
            $to
          } = ranges[i];
          const from = $from.pos;
          const to = $to.pos;

          if (has) {
            tr.removeMark(from, to, markType);
          } else if (isCellSelection && $from.parent.nodeSize === 4) {
            if (from > prePos && prePos !== null) insertTextCount++;
            prePos = from;
            tr.insert(from + insertTextCount + 1, schema.text('\u200B', [markType.create(attrs)]));
          } else {
            tr.addMark(from + insertTextCount, to + insertTextCount, markType.create(attrs));
          }
        }

        dispatch(tr);
      }
    }

    view.focus();
    return true;
  };
} // 设置上下标

function toggleSuMark(markType) {
  return function (state, dispatch, view) {
    const {
      tr,
      selection,
      schema
    } = state;
    const {
      empty,
      $cursor,
      ranges
    } = selection;
    const {
      sub,
      sup
    } = schema.marks;
    if (empty && !$cursor || !markApplies(state.doc, ranges, markType)) return false;

    if (dispatch) {
      if ($cursor) {
        if (markType.isInSet(state.storedMarks || $cursor.marks())) {
          dispatch(tr.removeStoredMark(markType));
        } else {
          let transaction = tr;

          if (sub.isInSet(state.storedMarks || $cursor.marks())) {
            transaction = transaction.removeStoredMark(sub);
          }

          if (sup.isInSet(state.storedMarks || $cursor.marks())) {
            transaction = transaction.removeStoredMark(sup);
          }

          dispatch(transaction.addStoredMark(markType.create()));
        }
      } else {
        let transaction = tr;

        const removeSubMark = subType => {
          let has = false;

          for (let i = 0; !has && i < ranges.length; i++) {
            const {
              $from,
              $to
            } = ranges[i];
            has = state.doc.rangeHasMark($from.pos, $to.pos, subType);
          }

          for (let i = 0; i < ranges.length; i++) {
            const {
              $from,
              $to
            } = ranges[i];

            if (has) {
              transaction = transaction.removeMark($from.pos, $to.pos, subType);
            }
          }

          return has;
        };

        const hasSub = removeSubMark(sub);
        const hasSup = removeSubMark(sup); // 已有对应上/下标，再次点击，则取消

        if (!(markType === sub && hasSub || markType === sup && hasSup)) {
          for (let i = 0; i < ranges.length; i++) {
            const {
              $from,
              $to
            } = ranges[i];
            transaction = transaction.addMark($from.pos, $to.pos, markType.create());
          }
        }

        dispatch(transaction);
        view.focus();
      }
    }

    return true;
  };
}
function insertHr() {
  return function (state, dispatch, view) {
    const node = state.schema.nodes.horizontal_rule.create();
    const {
      transaction
    } = index_js.insertBlock(state, node);
    if (!transaction) return false;
    dispatch(transaction.scrollIntoView());
    view.focus();
    return true;
  };
} // 清除格式

function clearFormat() {
  return function clearCommand(state, dispatch, view) {
    const {
      selection,
      schema,
      tr
    } = state;
    const {
      $cursor
    } = selection;
    const {
      paragraph,
      heading,
      list_item,
      task_item
    } = schema.nodes; // 清除光标左右两边的格式

    if ($cursor) {
      const cursor = $cursor.pos;
      const beforeNode = $cursor.nodeBefore;
      const afterNode = $cursor.nodeAfter;

      if (beforeNode) {
        Object.keys(schema.marks).forEach(mark => {
          tr.removeMark(cursor - beforeNode.nodeSize, cursor, mark.type);
        });
      }

      if (afterNode) {
        Object.keys(schema.marks).forEach(mark => {
          tr.removeMark(cursor, cursor + afterNode.nodeSize, mark.type);
        });
      }
    } // 处于 CellSelection 时可能有多个 range


    selection.ranges.forEach(range => {
      const from = range.$from.pos;
      const to = range.$to.pos;
      tr.doc.nodesBetween(from, to, (node, pos, parent) => {
        if (node.type === heading) {
          tr.setNodeMarkup(pos, paragraph, node.attrs);

          if ((parent.type === list_item || parent.type === task_item) && tr.doc.nodeAt(pos - 1)) {
            tr.setNodeMarkup(pos - 1, null, objectSpread({}, parent.attrs, {
              level: null
            }));
          }
        }
      });
      tr.setBlockType(from, to, schema.nodes.paragraph);
      Object.keys(schema.marks).forEach(mark => {
        tr.removeMark(from, to, mark.type);
      });
    });
    dispatch(tr);
    view.focus();
    return true;
  };
} // (color: string) → Command
// 参考 PM toggleMark 实现内联的颜色 Mark 处理 Command

function setTextColor(color) {
  return function (state, dispatch, view) {
    const colorType = state.schema.marks.color;
    const attrs = {
      color
    };
    const {
      empty,
      $cursor,
      ranges
    } = state.selection;

    if (empty && !$cursor || !markApplies(state.doc, ranges, colorType)) {
      return false;
    }

    if ($cursor) {
      // 不同于 toggleMark，此处不论原 color 如何，均添加新 color mark
      dispatch(state.tr.addStoredMark(colorType.create(attrs)));
    } else {
      let has = false;
      const {
        tr
      } = state;

      for (let i = 0; !has && i < ranges.length; i++) {
        const {
          $from,
          $to
        } = ranges[i];
        has = state.doc.rangeHasMark($from.pos, $to.pos, colorType);
      }

      for (let i = 0; i < ranges.length; i++) {
        const {
          $from,
          $to
        } = ranges[i]; // 不同于 toggleMark，此处不论原 color 如何，均添加新 color mark

        if (has) tr.removeMark($from.pos, $to.pos, colorType);
        tr.addMark($from.pos, $to.pos, colorType.create(attrs));
      }

      dispatch(tr);
      view.focus();
    }

    return true;
  };
} // (size: string) → Command
// 参考 学城 setTextColor 实现内联的字体大小 Mark 处理 Command

function setFontsize(size) {
  return function (state, dispatch, view) {
    const fontType = state.schema.marks.font;
    const attrs = {
      dataSize: size
    };
    const {
      empty,
      $cursor,
      ranges
    } = state.selection;

    if (empty && !$cursor || !markApplies(state.doc, ranges, fontType)) {
      return false;
    }

    if ($cursor) {
      // 不同于 toggleMark，此处不论原 color 如何，均添加新 color mark
      dispatch(state.tr.addStoredMark(fontType.create(attrs)));
    } else {
      let has = false;
      const {
        tr
      } = state;

      for (let i = 0; !has && i < ranges.length; i++) {
        const {
          $from,
          $to
        } = ranges[i];
        has = state.doc.rangeHasMark($from.pos, $to.pos, fontType);
      }

      for (let i = 0; i < ranges.length; i++) {
        const {
          $from,
          $to
        } = ranges[i]; // 不同于 toggleMark，此处不论原 color 如何，均添加新 color mark

        if (has) tr.removeMark($from.pos, $to.pos, fontType);
        tr.addMark($from.pos, $to.pos, fontType.create(attrs));
      }

      dispatch(tr);
    }

    return true;
  };
} // (color: string) → Command
// 参考 PM toggleMark 实现内联的颜色 Mark 处理 Command

function setTextDefaultColor() {
  return function (state, dispatch, view) {
    const colorType = state.schema.marks.color;
    const {
      empty,
      $cursor,
      ranges
    } = state.selection;

    if (empty && !$cursor || !markApplies(state.doc, ranges, colorType)) {
      return false;
    }

    if ($cursor) {
      dispatch(state.tr.removeStoredMark(colorType));
    } else {
      const {
        tr
      } = state;

      for (let i = 0; i < ranges.length; i++) {
        const {
          $from,
          $to
        } = ranges[i];
        tr.removeMark($from.pos, $to.pos, colorType);
      }

      dispatch(tr.scrollIntoView());
    }

    view.focus();
    return true;
  };
} // Inline from prosemirror-commands.

function splitBlock(state, dispatch) {
  const {
    selection,
    schema
  } = state;
  const {
    $from,
    $to,
    from
  } = selection;

  if (selection instanceof prosemirrorState.NodeSelection && selection.node.isBlock) {
    if (!$from.parentOffset || !prosemirrorTransform.canSplit(state.doc, $from.pos)) return false;
    if (dispatch) dispatch(state.tr.split($from.pos).scrollIntoView());
    return true;
  }

  if (dispatch) {
    const atStart = $to.parentOffset === 0;
    const atEnd = $to.parentOffset === $to.parent.content.size;
    const tr = state.tr;
    if (selection instanceof prosemirrorState.TextSelection) tr.deleteSelection();
    const parentNode = $from.node(-1);
    const deflt = $from.depth === 0 ? null : parentNode.defaultContentType($from.indexAfter(-1));
    let splitDepth = 1;

    if (atStart && ['blockquote', 'note_content', 'collapse_content', 'doc', 'table_cell', 'table_header'].includes(parentNode.type.name)) {
      let nodeType = parentNode.type;

      if (['table_cell', 'table_header', 'blockquote'].includes(parentNode.type.name)) {
        nodeType = schema.nodes.doc;
      }

      tr.insert(from, nodeType.createAndFill());
      tr.deleteRange(from, from + 2);
      dispatch(tr.scrollIntoView());
      return true;
    }

    if (atEnd && ['blockquote', 'note_content', 'collapse_content', 'doc', 'table_cell', 'table_header'].includes(parentNode.type.name)) {
      let nodeType = parentNode.type;

      if (['table_cell', 'table_header', 'blockquote'].includes(parentNode.type.name)) {
        nodeType = schema.nodes.doc;
      }

      tr.insert(from, nodeType.createAndFill());
      tr.deleteRange(from + 4, from + 5);
      tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, from + 2));
      dispatch(tr.scrollIntoView());
      return true;
    } // 处理inline类型（链接）


    if (deflt === schema.nodes.text) {
      // 行首或行尾
      if (!$from.nodeBefore || !$to.nodeAfter) {
        tr.insert(from, parentNode.type.createAndFill());
        tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, from + 2));
        tr.delete(from + 2, from + 4);
        dispatch(tr.scrollIntoView());
        return true;
      }

      splitDepth = 2;
    } // HACK here


    let types = atEnd ? [{
      type: deflt,
      attrs: getAttrs(state)
    }] : null;
    let can = prosemirrorTransform.canSplit(tr.doc, $from.pos, 1, types);

    if (!types && !can && prosemirrorTransform.canSplit(tr.doc, tr.mapping.map($from.pos), splitDepth, deflt && [{
      type: deflt
    }])) {
      types = [{
        type: deflt
      }];
      can = true;
    }

    if (can) {
      tr.split(tr.mapping.map($from.pos), splitDepth, types || [{
        type: deflt,
        attrs: {
          dataDiffId: `ct-diff-id-${uuid()}`
        }
      }]);

      if (!atEnd && !$from.parentOffset && $from.parent.type !== deflt && $from.node(-1).canReplace($from.index(-1), $from.indexAfter(-1), prosemirrorModel.Fragment.from(deflt.create(), $from.parent))) {
        tr.setNodeMarkup(tr.mapping.map($from.before()), deflt);
      }
    }

    dispatch(tr.scrollIntoView());
  }

  return true;
} // Acts like [`splitBlock`](#commands.splitBlock), but without
// resetting the set of active marks at the cursor.


function splitBlockKeepMarks(state, dispatch) {
  return splitBlock(state, dispatch && (tr => {
    const marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();
    if (marks) tr.ensureMarks(marks);
    dispatch(tr);
  }));
} // :: (EditorState, ?(tr: Transaction)) → bool
// If a block node is selected, create an empty paragraph before (if
// it is its parent's first child) or after it.

function createParagraphNear(state, dispatch) {
  const {
    selection
  } = state;
  const {
    $from,
    $to
  } = selection;

  if ($from.parent.inlineContent || $to.parent.inlineContent) {
    return false;
  }

  const type = $from.parent.defaultContentType($to.indexAfter());

  if (!type || !type.isTextblock) {
    return false;
  }

  if (dispatch) {
    const isGapCursor = selection instanceof index_js$1.GapCursor;
    const gapCursor = isGapCursor ? index_js$1.getGapCursor() : {};
    const side = (!$from.parentOffset && $to.index() < $to.parent.childCount ? $from : $to).pos;
    const tr = state.tr.insert(side, type.createAndFill());
    const pos = side + (isGapCursor && gapCursor.dir === 'after' ? 2 : 1);
    tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, pos));
    dispatch(tr);
  }

  return true;
}

const setTitleFontSize = level => {
  let type;

  switch (level) {
    case 1:
      type = 28;
      break;

    case 2:
      type = 24;
      break;

    case 3:
      type = 20;
      break;

    case 4:
      type = 16;
      break;

    case 5:
      type = 14;
      break;

    case 6:
      type = 12;
      break;

    default:
      type = 14;
  }

  return type;
}; // (state: EditorState) -> boolean


function isTextBlock(state) {
  const {
    selection,
    tr
  } = state;
  let is = true; // 处于 CellSelection 时可能有多个 range

  selection.ranges.forEach(range => {
    const from = range.$from.pos;
    const to = range.$to.pos;
    tr.doc.nodesBetween(from, to, node => {
      const type = node.type;
      if (type.isLeaf && type.name !== 'hard_break' && type.name !== 'text' && type.name !== 'image' && type.name !== 'drawio' && !type.isTextblock) is = false;
      return is;
    });
  });
  return is;
}
function isWeirdBlock(state) {
  const {
    selection,
    tr
  } = state;
  let is = false; // 处于 CellSelection 时可能有多个 range

  selection.ranges.forEach(range => {
    const from = range.$from.pos;
    const to = range.$to.pos;
    tr.doc.nodesBetween(from, to, node => {
      if (node.attrs.weird) is = true;
      return !is;
    });
  });
  return is;
} // Helpers to get current attrs from empty node.

function getAttrs(state) {
  if (!state.selection.empty) return {};
  const {
    from,
    to
  } = state.selection;
  let result = {};
  state.tr.doc.nodesBetween(from, to, node => {
    result = node.attrs;
  });
  delete result.dataDiffId;
  return result;
} // (state: EditorState) -> string

function getTextBlockType(state) {
  const {
    selection,
    tr,
    schema
  } = state;
  const {
    paragraph,
    heading,
    status,
    font
  } = schema.nodes;
  let type = null; // 是否在状态中

  if (status) {
    const isInStatus = selection.node && selection.node.type === status || index_js.findParentNode(selection.$from.path, node => node.type === status);
    if (isInStatus) return type;
  } // 处于 CellSelection 时可能有多个 range


  selection.ranges.forEach(range => {
    const from = range.$from.pos;
    const to = range.$to.pos;
    tr.doc.nodesBetween(from, to, node => {
      if (type !== null) return false;
      if (node.type === paragraph) type = '正文';else if (node.type === heading) {
        const {
          level
        } = node.attrs;
        type = `${['😜', '一', '二', '三', '四', '五', '六'][level]}级标题`;
      }
    });
  });
  return type;
}
function getTextFontsize(state) {
  const {
    selection,
    tr,
    schema
  } = state;
  const {
    paragraph,
    heading,
    collapse,
    table,
    text,
    collapse_content,
    table_row,
    table_header,
    table_cell,
    hard_break
  } = schema.nodes;
  const {
    font
  } = schema.marks;
  let type = ' - ';
  const availableType = [paragraph, heading, collapse, collapse_content, table, table_header, table_cell, table_row, text, hard_break];
  let nodeList = [];

  const findFontMark = m => {
    return m.type === font && m.attrs.dataSize;
  }; // 处于 CellSelection 时可能有多个 range


  selection.ranges.forEach(range => {
    const from = range.$from.pos;
    const to = range.$to.pos;

    if (from !== to) {
      tr.doc.nodesBetween(from, to, (node, pos, parent) => {
        //if (type !== null) return false
        if (availableType.indexOf(node.type) === -1) return false;
        if (node.type === text || node.type === heading) nodeList.push(node);
        if (node.type === heading) return false;
      });
    } else {
      //HACK 没有选中区域时，判断前置的内容
      type = 14; // //行内放置光标，heading的情况
      // if (range.$to.parent && range.$to.parent.type === heading) {
      //   type = setTitleFontSize(range.$to.parent.attrs.level)
      // }
      //段落中的情况, 字体用光标之前的字体的大小展示
      //段落中只可能是标题或者正文

      if (range.$to.nodeAfter !== null && range.$to.nodeBefore !== null) {
        //HEADING的情况
        if (range.$to.parent && range.$to.parent.type === heading) {
          type = setTitleFontSize(range.$to.parent.attrs.level);
        } else {
          //正文文本
          const fontMark = range.$to.nodeBefore.marks.filter(findFontMark);
          if (fontMark.length > 0) type = fontMark[0].attrs.dataSize;
        }
      } else {
        if (range.$to.nodeAfter === null && range.$to.nodeBefore === null) {
          const hasFont = hasMark(state, font);

          if (hasFont) {
            type = hasFont.attrs.dataSize;
            return;
          }
        }

        let nodePosition = 'nodeBefore';
        if (range.$to.nodeBefore === null) nodePosition = 'nodeAfter';

        if (range.$to.parent && range.$to.parent.type === heading) {
          type = setTitleFontSize(range.$to.parent.attrs.level);
        } else {
          const calculateNode = range.$to[nodePosition];
          if (!calculateNode) return;
          const fontMark = calculateNode.marks.filter(findFontMark);
          if (fontMark.length > 0) type = fontMark[0].attrs.dataSize;
        }
      } //段首的情况
      //段末尾的情况


      if (range.$to.nodeAfter === null && range.$to.nodeBefore && range.$to.nodeBefore.type === text) {
        const fm = range.$to.nodeBefore.marks.filter(findFontMark);
        if (fm.length > 0) type = fm[0].attrs.dataSize;
      }
    }
  });
  /**
   * 拿到除开整段之外的子节点
   * 1. 单个子节点，判断各自的类型和字体字号
   * 2. 多个子节点
   *   a. 不同类型子节点，则 -
   *   b. 同类子节点
   *      b1. 同类heading, level 不同 -
   *      b2. 同类heading, level同， 则level
   *      b3. 同类text, 拿出fontmarks
   *        b3.1 若fontmarks.lenght < text.length 说明有不存在font的， -
   *        b3.2 lenght相同， font不同，-
   *        b3.3 lenght同，font同，设置font
   */

  if (nodeList.length === 1) {
    //单个heading
    if (nodeList[0].type === heading) {
      const {
        level
      } = nodeList[0].attrs;
      type = setTitleFontSize(level);
    } else {
      //单个text
      const fontMark = nodeList[0].marks.filter(findFontMark);

      if (fontMark.length > 0) {
        type = fontMark[0].attrs.dataSize;
      } else {
        type = 14;
      }
    }
  } else if (nodeList.length !== 0) {
    let hasDiffType = false;
    nodeList.reduce((acc, current) => {
      if (acc.type !== current.type) hasDiffType = true;
      return current;
    }); //有不同类型

    if (!hasDiffType) {
      //同一类型
      //heading
      if (nodeList[0].type === heading) {
        const uniqueLevels = new Set();
        nodeList.forEach(n => uniqueLevels.add(n.attrs.level));

        if (uniqueLevels.length === 1) {
          type = setTitleFontSize(uniqueLevels[0]);
        }
      } else {
        //text
        const fontMarks = [];
        nodeList.forEach(n => {
          const fm = n.marks.filter(findFontMark);
          if (fm.length > 0) fontMarks.push(fm[0]);
        }); //没有mark,设置为默认大小

        if (fontMarks.length === 0) {
          type = 14;
        } else if (fontMarks.length === nodeList.length) {
          const size = new Set();
          fontMarks.forEach(fm => size.add(fm.attrs.dataSize));
          if (size.size === 1) type = size.values().next().value;
        }
      }
    }
  }

  return type;
}
function canSetFontsize(state) {
  const {
    selection,
    tr,
    schema
  } = state;
  const {
    paragraph,
    table,
    table_cell,
    table_header,
    table_row,
    collapse,
    collapse_content,
    text,
    hard_break
  } = schema.nodes;
  let bool = true; // 处于 CellSelection 时可能有多个 range

  selection.ranges.forEach(range => {
    const from = range.$from.pos;
    const to = range.$to.pos;
    tr.doc.nodesBetween(from, to, node => {
      if (node.type !== paragraph && node.type !== table && node.type !== table_cell && node.type !== table_header && node.type !== table_row && node.type !== collapse && node.type !== collapse_content && node.type !== hard_break && node.type !== text) bool = false;
    });
  });
  return bool;
}
function isInParagraph(state) {
  const {
    selection,
    tr,
    schema
  } = state;
  const {
    paragraph
  } = schema.nodes;
  let bool = false; // 处于 CellSelection 时可能有多个 range

  selection.ranges.forEach(range => {
    const from = range.$from.pos;
    const to = range.$to.pos;

    if (from === to) {
      tr.doc.nodesBetween(from, to, node => {
        if (node.type !== paragraph) bool = true;
      });
    }
  });
  return bool;
}
function isInHeading(state) {
  const {
    selection,
    tr,
    schema
  } = state;
  const {
    heading
  } = schema.nodes;
  const topLevelNodeList = [];
  selection.ranges.forEach(range => {
    const from = range.$from.pos;
    const to = range.$to.pos;
    tr.doc.nodesBetween(from, to, node => {
      topLevelNodeList.push(node);
      return false;
    });
  });
  const {
    $from
  } = selection;
  const isHeading = index_js.findParentNode($from.path, item => item.type && item.type.name === "heading");
  return !!isHeading || topLevelNodeList.some(p => p.type === heading);
} // (state: EditorState, type: MarkType) -> boolean

function hasMark(state, type) {
  const {
    selection,
    doc,
    schema
  } = state;
  const {
    from,
    to,
    $from,
    empty,
    $cursor
  } = selection; // 表头粗体

  if ($cursor && schema.marks.strong === type && schema.nodes.table_header) {
    const path = $cursor.path;
    const headerType = schema.nodes.table_header;
    const isInTableHeader = path.some(p => p.type === headerType);
    if (isInTableHeader) return true;
  }

  if (empty) {
    return type.isInSet(state.storedMarks || $from.marks());
  } // 处理表格选中


  if (selection.constructor.name === 'CellSelection') {
    const ranges = selection.ranges;
    return ranges.every(range => {
      const {
        $to
      } = range;
      return doc.rangeHasMark($from.pos, $to.pos, type);
    });
  }

  return doc.rangeHasMark(from, to, type);
} // (state: EditorState, align: 'left' | 'center' | 'right') -> boolean

function isAlignedBlock(state, view, align) {
  const {
    selection
  } = state;
  const {
    ranges,
    $anchor,
    node
  } = selection; // 处理表格选中

  if (selection.constructor.name === 'CellSelection') {
    return ranges.every(range => {
      const {
        $from
      } = range;
      const node = $from.node().firstChild;
      if (!node) return false;
      const attrs = node.attrs;
      if (attrs.align === '' && align === 'left') return true;
      if (!attrs.align) return false;
      return attrs.align === align;
    });
  } // 虚拟光标前后的块


  if (selection instanceof index_js$1.GapCursor) {
    const {
      $from,
      dom
    } = selection;
    const {
      nodeBefore,
      nodeAfter,
      pos
    } = $from;
    if (!dom) return false;
    let domPos;

    try {
      domPos = view.docView.posFromDOM(dom);
    } catch (error) {
      return false;
    }

    if (nodeBefore && nodeBefore.type.spec.alignBlock && nodeBefore.type.isAtom && domPos < pos) {
      const attrs = nodeBefore.attrs;
      if (attrs.align === '' && align === 'left') return true;
      if (!attrs.align) return false;
      return attrs.align === align;
    }

    if (nodeAfter && nodeAfter.type.spec.alignBlock && nodeAfter.type.isAtom && domPos === pos) {
      const attrs = nodeAfter.attrs;
      if (attrs.align === '' && align === 'left') return true;
      if (!attrs.align) return false;
      return attrs.align === align;
    }
  }

  const alignNode = node || $anchor.parent;
  const attrs = alignNode.attrs;
  if (attrs.align === '' && align === 'left') return true;
  if (!attrs.align) return false;
  return attrs.align === align;
}
function canAlign(state, view) {
  return setAlign('left')(state, undefined, view);
} // 是否可缩进

function canIndent(state, direction) {
  return setIndent(direction)(state);
} // (node: Node, level: number) -> { level, indent, align }

function getHeadingAttrs(node, level = null) {
  const align = node.style.textAlign;
  const indent = parseInt(node.style.marginLeft, 10) / 20 || 0;
  const dataDiffId = node.getAttribute('data-diff-id');
  const attrs = {
    id: uuid(),
    // 修复数据脏数据问题，每次重新给heading分配一个id
    indent,
    // 过滤可能的 justify
    align: align === 'justify' ? 'left' : align,
    dataDiffId: dataDiffId || `ct-diff-id-${uuid()}` // 根据 paragraph 或 heading 返回不同 attrs

  };
  return level === null ? attrs : objectSpread({
    level
  }, attrs);
} // 新增零宽度的空白字符
// () -> string

function uuid() {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  const id = [];

  for (let i = 0; i < 8; i++) {
    id.push(chars[parseInt(Math.random() * chars.length, 10)]);
  }

  return id.join('');
}

// 若相应节点已抽离出插件，请将相应 node 提取至插件 schema 中

var nodes = {
  // :: NodeSpec The top level document node.
  doc: {
    content: 'block+'
  },
  // :: NodeSpec The text node.
  text: {
    group: 'inline'
  },
  // :: NodeSpec A plain paragraph textblock. Represented in the DOM
  // as a `<p>` element.
  paragraph: {
    attrs: {
      indent: {
        default: 0
      },
      align: {
        default: 'left'
      },
      dataDiffId: {
        default: null
      }
    },
    content: 'inline*',
    group: 'block',
    textContentBlock: true,
    alignBlock: true,
    parseDOM: [{
      tag: 'p',
      preserveWhitespace: 'full',
      getAttrs: dom => getHeadingAttrs(dom)
    }],

    toDOM(node) {
      const {
        align,
        indent,
        dataDiffId
      } = node.attrs;
      const attrs = {};
      let style = '';

      if (align && align !== 'left') {
        style += `text-align: ${align};`;
      }

      if (indent) {
        style += `margin-left: ${Math.max(indent, 0) * 20}px;`;
      }

      if (style) {
        attrs.style = style;
      }

      attrs['data-diff-id'] = dataDiffId || `ct-diff-id-${uuid()}`;
      return ['p', attrs, 0];
    }

  },
  // :: NodeSpec A heading textblock, with a `level` attribute that
  // should hold the number 1 to 6. Parsed and serialized as `<h1>` to
  // `<h6>` elements.
  heading: {
    attrs: {
      id: {
        default: ''
      },
      level: {
        default: 1
      },
      indent: {
        default: 0
      },
      align: {
        default: 'left'
      },
      dataDiffId: {
        default: null
      }
    },
    content: 'inline*',
    textContentBlock: true,
    group: 'block',
    defining: true,
    alignBlock: true,
    parseDOM: [1, 2, 3, 4, 5, 6].map(level => ({
      tag: `h${level}`,
      preserveWhitespace: 'full',
      getAttrs: dom => getHeadingAttrs(dom, level)
    })),

    toDOM(node) {
      const {
        level,
        align,
        indent,
        id,
        dataDiffId
      } = node.attrs;
      const attrs = {
        id: id ? id : uuid()
      };
      let style = '';

      if (align && align !== 'left') {
        style += `text-align: ${align};`;
      }

      if (indent) {
        style += `margin-left: ${Math.max(indent, 0) * 20}px;`;
      }

      if (style) {
        attrs.style = style;
      }

      attrs.class = 'ct-heading';
      attrs['data-diff-id'] = dataDiffId || `ct-diff-id-${uuid()}`;
      return [`h${level}`, attrs, 0];
    }

  },
  // :: NodeSpec A hard line break, represented in the DOM as `<br>`.
  hard_break: {
    inline: true,
    group: 'inline',
    selectable: false,
    parseDOM: [{
      tag: 'br'
    }],

    toDOM() {
      return ['br'];
    }

  },
  // :: NodeSpec A horizontal rule (`<hr>`).
  horizontal_rule: {
    group: 'block',
    allowGapCursor: true,
    insertBlock: true,
    attrs: {
      dataDiffId: {
        default: null
      }
    },
    parseDOM: [{
      tag: 'hr',
      getAttrs: dom => {
        const dataDiffId = dom.getAttribute('data-diff-id');
        return {
          dataDiffId
        };
      }
    }],

    toDOM(dom) {
      const {
        dataDiffId
      } = dom.attrs;
      const attrs = {
        'data-diff-id': dataDiffId || `ct-diff-id-${uuid()}`
      };
      return ['hr', attrs];
    }

  }
};

const calculateheigth = fontSize => {
  let lineHeight;

  switch (fontSize) {
    case 12:
    case 13:
    case 14:
    case 16:
      lineHeight = 24;
      break;

    default:
      lineHeight = parseInt(fontSize) + 8;
      break;
  }

  return lineHeight;
}; // 基础 mark 由 ProseMirror 官方默认 basic-schema 内联
// 若相应节点已抽离出插件，请将相应 mark 提取至插件 schema 中


var marks = {
  // :: MarkSpec An emphasis mark. Rendered as an `<em>` element.
  // Has parse rules that also match `<i>` and `font-style: italic`.
  em: {
    parseDOM: [{
      tag: 'i'
    }, {
      tag: 'em'
    }, {
      style: 'font-style=italic'
    }],

    toDOM() {
      return ['em'];
    }

  },
  // :: MarkSpec A strong mark. Rendered as `<strong>`, parse rules
  // also match `<b>` and `font-weight: bold`.
  strong: {
    parseDOM: [{
      tag: 'strong'
    }, // This works around a Google Docs misbehavior where
    // pasted content will be inexplicably wrapped in `<b>`
    // tags with a font-weight normal.
    {
      tag: 'b',
      getAttrs: node => node.style.fontWeight !== 'normal' && null
    }, {
      style: 'font-weight',
      getAttrs: value => /^(bold(er)?|[5-9]\d{2,})$/.test(value) && null
    }],

    toDOM() {
      return ['strong'];
    }

  },
  underline: {
    parseDOM: [{
      tag: 'u'
    }, {
      style: 'text-decoration=underline'
    }],

    toDOM() {
      return ['u'];
    }

  },
  strikethrough: {
    parseDOM: [{
      tag: 'del'
    }, {
      style: 'text-decoration=line-through'
    }],

    toDOM() {
      return ['del'];
    }

  },
  color: {
    attrs: {
      color: {
        default: '#333'
      }
    },
    parseDOM: [{
      priority: 20,
      tag: 'span[style*=color]',
      getAttrs: node => ({
        color: node.style.color
      })
    }],

    toDOM(node) {
      return ['span', {
        style: `color: ${node.attrs.color}`
      }];
    }

  },
  sup: {
    parseDOM: [{
      tag: 'sup'
    }],

    toDOM() {
      return ['sup'];
    }

  },
  sub: {
    parseDOM: [{
      tag: 'sub'
    }],

    toDOM() {
      return ['sub'];
    }

  },
  font: {
    attrs: {
      dataSize: {
        default: 14
      }
    },
    parseDOM: [{
      tag: 'font',
      getAttrs: dom => {
        const size = dom.getAttribute('data-size') || 14;
        return {
          dataSize: size
        };
      }
    }],

    toDOM(node) {
      const lineHeight = calculateheigth(node.attrs.dataSize);
      const style = {
        style: `font-size:${node.attrs.dataSize}px;line-height:${lineHeight}px`,
        'data-size': node.attrs.dataSize
      };
      return ['font', style];
    }

  }
};

/* eslint-disable camelcase */

function handleBackspace(state, dispatch, view) {
  const {
    tr,
    selection,
    schema,
    doc
  } = state;
  let {
    $from,
    from,
    to
  } = selection;
  const {
    $to,
    $cursor
  } = selection;
  const {
    paragraph,
    horizontal_rule,
    link,
    ordered_list,
    bullet_list,
    task_list,
    list_item,
    task_item
  } = schema.nodes;
  const listTypes = [ordered_list, bullet_list, task_list];
  const itemTypes = [list_item, task_item];
  let fromNode = $from.node();
  const toNode = $to.node();

  if (selection instanceof prosemirrorState.NodeSelection) {
    dispatch(tr.deleteSelection().setSelection(prosemirrorState.TextSelection.create(tr.doc, from)));
    view.focus();
    return true;
  } // 虚拟光标的处理：光标在块后面 -> 选中；光标在行内后面 -> 删除；光标在前面 -> 删除前一行末尾


  let isGapCursor = false;

  if (selection instanceof index_js$1.GapCursor) {
    const res = index_js$1.GapCursor.findFrom($from);

    if (res && res.dir === 'before') {
      index_js$1.setLastAction('delete'); // 代码块要通过 TextSelection 来选中

      if (res.node.type.name === 'code_block') {
        const newSelection = prosemirrorState.TextSelection.create(tr.doc, res.pos - res.node.nodeSize, res.pos);
        dispatch(tr.setSelection(newSelection));
      } else {
        const newSelection = prosemirrorState.NodeSelection.create(tr.doc, res.pos - res.node.nodeSize);
        dispatch(tr.setSelection(newSelection));
      }

      return true;
    }

    isGapCursor = true;
    from = res.pos;
    to = res.pos;
    $from = doc.resolve(res.pos);
    fromNode = res.node;
  } // 光标在行首


  if ($from.parentOffset === 0 || isGapCursor) {
    if ($cursor || isGapCursor) {
      const fromNodeParent = isGapCursor ? $from.node() : $from.node(-1);
      if (!fromNodeParent) return false;
      const isDocHead = from === 1; // 光标是否在文档头部
      // const isLastChild = fromNodeParent.lastChild === fromNode

      let preBlockNode = isDocHead ? false : index_js.getBlockNode(state, from - 3, from - 1); // 前一行节点是否为普通文本

      if (preBlockNode && index_js.isChild(fromNode, preBlockNode)) preBlockNode = false; // 块元素后删除，显示块元素后的光标

      if (preBlockNode) {
        const newSelection = prosemirrorState.TextSelection.create(tr.doc, from - 1);

        if (fromNode.childCount === 0) {
          tr.delete(from - 1, to + 1);
        }

        dispatch(tr.setSelection(newSelection));
        return true;
      } // 有缩进时删除相当于减少缩进


      if (fromNode.type === paragraph && fromNode.attrs.indent > 0) {
        setIndent('less')(state, dispatch, view);
        return true;
      } // 块内首行为空时删除并将光标跳到后一行（如文档首行，单元格首行）


      const parentContent = fromNodeParent.content.content;

      if (fromNode.content.size === 0 && !itemTypes.includes(fromNodeParent.type) && parentContent[0] === $from.parent) {
        const secondNode = parentContent[1];

        if (secondNode && listTypes.includes(secondNode.type)) {
          tr.replaceWith(from - 1, to + secondNode.nodeSize + 1, secondNode);
          dispatch(tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, from + 1)));
          return true;
        }

        if (parentContent.length !== 1 && parentContent[0] === fromNode) {
          if (parentContent[0].type.name === "collapse_title" && parentContent[0].type.name === "note_title" && parentContent[0].attrs.align) {
            return false;
          }

          tr.delete(from - 1, to + 1);
          dispatch(tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, from - 1)));
          return true;
        }
      }

      if (isGapCursor && from > 1) {
        if ($from.parentOffset !== 0) {
          tr.delete(from - 1, to);
          dispatch(tr.setSelection(prosemirrorState.TextSelection.create(doc, from - 1)));
          return true;
        } else {
          // 行首特殊处理，删两格
          tr.delete(from - 2, to);
          dispatch(tr);
          return true;
        }
      }
    } else {
      // 删除水平线
      if ($from.nodeAfter && $from.nodeAfter.type === horizontal_rule) {
        dispatch(tr.replaceWith(from + 1, to, paragraph.create()));
      } // 删除链接


      if (fromNode.type === link && fromNode === toNode && to - from === fromNode.content.size) {
        dispatch(tr.delete(from, to + 1));
      }
    }
  }

  return false;
} // 向后删除动作处理

function handleDelete(state, dispatch) {
  const {
    tr,
    selection,
    doc
  } = state;
  const {
    $cursor,
    $from,
    to
  } = selection;
  const fromNode = $from.node();
  const fromSize = fromNode.content.size; // 虚拟光标的处理

  if (selection instanceof index_js$1.GapCursor) {
    index_js$1.setLastAction('delete');
    const res = index_js$1.GapCursor.findFrom($from);
    const resAfter = index_js$1.GapCursor.findFrom($from, 'after');

    if (res && res.dir === 'after' || resAfter && resAfter.dir === 'after') {
      // 代码块要通过 TextSelection 来选中
      if (res.node.type.name === 'code_block') {
        const newSelection = prosemirrorState.TextSelection.create(tr.doc, res.pos, res.pos + res.node.nodeSize);
        dispatch(tr.setSelection(newSelection));
      } else {
        dispatch(tr.setSelection(prosemirrorState.NodeSelection.create(doc, res.pos)));
      }

      return true;
    }

    const pos = res.pos;
    const nodeAfter = doc.resolve(res.pos).nodeAfter;

    if (pos < doc.content.size) {
      if (!nodeAfter && pos < doc.content.size - 1) {
        tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, pos + 2));
      } else if (res.node.isBlock) {
        tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, pos + 1));
      } else if (nodeAfter) {
        tr.delete(pos, pos + 1);
      }
    }

    dispatch(tr);
    return true;
  } // 光标在行尾


  if ($cursor && $from.parentOffset === fromSize) {
    const fromNodeParent = $from.node(-1);
    if (!fromNodeParent) return false; // const isDocHead = from === 1 // 光标是否在文档头部

    const isDocTail = to === doc.content.size - 1; // 光标是否在文档尾部
    // const isFirstChild = fromNodeParent.firstChild === fromNode
    // const isLastChild = fromNodeParent.lastChild === fromNode
    // const preBlockNode = isDocHead ? false : getBlockNode(state, from - 3, from - 1) // 前一行节点是否为普通文本

    const nextBlockNode = isDocTail ? false : index_js.getBlockNode(state, to + 1, to + 3); // 后一行节点是否为普通文本
    // 块元素前删除处理并将光标跳到新行首或选中

    if (nextBlockNode) {
      const plus = fromNode.isBlock ? 1 : 2;

      if (nextBlockNode.nodeSize === 1) {
        dispatch(tr.delete(to + plus, to + plus + 1));
      } else {
        dispatch(tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, to + plus, to + plus + nextBlockNode.nodeSize + 1)));
      }

      return true;
    } // // 块元素前后不可删除空行
    // if ((preBlockNode && (nextBlockNode || isLastChild)) || (nextBlockNode && isFirstChild)) return true

  }

  return false;
} // 回车处理（换段）

function handleEnter(state, dispatch, view) {
  const {
    tr,
    selection
  } = state;

  if (selection instanceof prosemirrorState.AllSelection) {
    tr.deleteSelection();
    dispatch(tr);
    return true;
  }

  return prosemirrorCommands.chainCommands(prosemirrorCommands.newlineInCode, createParagraphNear, prosemirrorCommands.liftEmptyBlock, splitBlockKeepMarks)(state, dispatch, view);
} // shift回车处理（换行）

function handleShiftEnter(state, dispatch, view) {
  const {
    tr,
    selection,
    schema
  } = state;
  const {
    $cursor,
    $from
  } = selection;
  const {
    hard_break
  } = schema.nodes;
  const $c = selection instanceof index_js$1.GapCursor ? $from : $cursor;

  if ($c && $c.parent.type.spec.textContentBlock) {
    tr.insert($c.pos, hard_break.createAndFill());
    dispatch(tr);
    return true;
  }

  return handleEnter(state, dispatch, view);
} // (...args) -> boolean

function outsideTableCommands(state, dispatch, view, store, isList, isShift, isText, isTextStart) {
  // 在段首按 tab，修改段落缩进
  if (isText && isTextStart) {
    const command = isShift ? setIndent('less') : setIndent('more');
    command(state, dispatch, view);
    return true;
  } // 在段中按 tab，增加四个空格，但此时 shift-tab 为减少缩进
  else if (isText && !isTextStart) {
      if (!isShift) {
        const {
          tr
        } = state;
        dispatch(tr.insertText('    '));
        return true;
      }

      const command = setIndent('less');
      command(state, dispatch, view);
      return true;
    } // 在列表中按 tab，修改该列表项缩进
    else if (isList) {
        const {
          sinkListItem,
          liftListItem
        } = store.listCommands;
        const command = isShift ? liftListItem : sinkListItem;
        command(state, dispatch);
        return true;
      } // 交由可能的其它插件处理


  return false;
} // (isShift: boolean, store: EditorStore) -> Command


function TabKeymap(isShift, store) {
  // 该 Command 封装多种可能的 Command 操作，亦可能不执行 Command
  // 返回 boolean 标志是否匹配后续 Keymap 插件
  // (state, dispatch, view) -> boolean
  return function tabCommand(state, dispatch, view) {
    const isText = isTextBlock(state);
    const isInList = store.editor.listUtils && store.editor.listUtils.isInList(state);
    const isInTable = store.editor.tableUtils && store.editor.tableUtils.isInTable(state);
    const isTextStart = state.selection.$from.parentOffset === 0; // 当前内容是否为列表项的情形

    if (isInList) {
      const {
        sinkListItem,
        liftListItem
      } = store.editor.listCommands;
      const command = isShift ? liftListItem : sinkListItem;
      command(state, dispatch, view);
      return true;
    } // 不在表格内时，区分段首、段中、列表中的三种情形


    if (!isInTable) {
      return outsideTableCommands(state, dispatch, view, store, isInList, isShift, isText, isTextStart);
    }

    return false;
  };
}

const tableTestReg = /<table[^>]*?data-pm-slice="/;
const tablePMDataTestReg = /data-pm-slice="[^>]*?\[\]"/;
const codeTestReg = /class="ct-code"[^>]*?data-pm-slice="/;
const noteTestReg = /class="ct-note-[^>]*?data-pm-slice="/;
const noteExecReg = /class="ct-note-[^>]*>([\s\S]*?)<\/div>/;
const collapseTestReg = /class="ct-collapse-[^>]*?data-pm-slice="/;
const collapseExecReg = /class="ct-collapse-[^>]*>([\s\S]*?)<\/div>/;
const basicTestReg = /class="ct-basic"[^>]*?data-pm-slice="1 1/;
const basicExecReg = /class="ct-basic"[^>]*>([\s\S]*?)<\/span>/;
const confluenceTableTestReg = /confluenceTable/;

class HTMLTransformer {
  constructor(htmlStr) {
    this.parsePMSlice = () => {
      this.htmlString;
      let removePMSlice = true;

      if (this.htmlString.includes('data-pm-slice="')) {
        if (!this.htmlString.includes('data-pm-slice="none"')) {
          // pm单元格内容粘贴
          if (tableTestReg.test(this.htmlString)) {
            if (!tablePMDataTestReg.test(this.htmlString)) {
              // removePMSlice = false
              // } else {
              this.htmlString = this.htmlString.replace(/<table.*?<td.*?>/g, '').replace(/<\/td><\/tr><\/tbody><\/table>/g, '');
            }
          } else if (codeTestReg.test(this.htmlString)) {
            removePMSlice = false;
          } else if (basicTestReg.test(this.htmlString)) {
            this.htmlString = basicExecReg.exec(this.htmlString)[1];
          } else if (noteTestReg.test(this.htmlString)) {
            this.htmlString = noteExecReg.exec(this.htmlString)[1];
          } else if (collapseTestReg.test(this.htmlString)) {
            this.htmlString = collapseExecReg.exec(this.htmlString)[1];
          }
        }

        if (removePMSlice) this.htmlString = this.htmlString.replace(/ data-pm-slice="[^>]*?"/g, '');
      }

      return this;
    };

    this.parseExcel = () => {
      // Excel/WPS粘贴
      if (this.htmlString.includes('xmlns:o="urn:schemas-microsoft-com:office:office"') && this.htmlString.includes('xmlns:x="urn:schemas-microsoft-com:office:excel"')) {
        this.htmlString = this.htmlString // .replace(/^[\s\S]*(<html)/, '$1')
        .replace(/(<\/html>)[\s\S]*$/, '$1').replace(/<br>\s*/g, '<br>\u200B'); // 零宽度字符替换br后多余空白符
      }

      return this;
    };

    this.parseWikiTable = () => {
      if (confluenceTableTestReg.test(this.htmlString)) {
        this.htmlString = this.htmlString.replace(/<tbody><tr><tr>/g, '<tbody><tr>').replace(/background-color: rgb\(224, 224, 224\) !important;/g, 'background-color: #F6F6F6;').replace(/\sbackground-color: rgb\(237, 245, 255\) !important;/g, '').replace(/<thead[^>]*?tableFloatingHeader[^O].*?<\/thead>/g, ''); // 浏览态克隆的表头行
      }

      return this;
    };

    this.parseWikiTable = () => {
      if (confluenceTableTestReg.test(this.htmlString)) {
        this.htmlString = this.htmlString.replace(/<tbody><tr><tr>/g, '<tbody><tr>').replace(/background-color: rgb\(224, 224, 224\) !important;/g, 'background-color: #F6F6F6;').replace(/\sbackground-color: rgb\(237, 245, 255\) !important;/g, '').replace(/<thead[^>]*?tableFloatingHeader[^O].*?<\/thead>/g, ''); // 浏览态克隆的表头行
      }

      return this;
    };

    this.pareseCode = () => {
      // PPT粘贴
      if (this.htmlString.includes('xmlns:m="http://schemas.microsoft.com/office/2004/12/omml"')) {
        return this;
      } // 代码块除外的换行符转换为br


      if (!this.htmlString.includes('ct-code') && !this.htmlString.includes('ct-html')) {
        this.htmlString = this.htmlString.replace(/<body>([\s\S]*)<\/body>/g, word => word.replace(/\n</g, '<').replace(/>\s*\n/g, '>').replace(/\n/g, '<br />'));
      } // 浏览态复制代码块换行符


      if (this.htmlString.includes('ct-code')) {
        this.htmlString = this.htmlString.replace(/<div class="title[^>]*?>([^<].*?)<\/div>/g, '<div class="title" data-title="$1"></div>').replace(/<div class="language[^>]*?>([^<].*?)<\/div>/g, '<div class="language" data-language="$1"></div>').replace(/<span[^>]*?cm-text.*?<\/span>/g, '').replace(/(<pre[^>]*?CodeMirror-line.*?)(<\/pre>)/g, '$1\n$2');
      }

      return this;
    };

    this.otherFilter = () => {
      this.htmlString = this.htmlString.replace(/(<a[^>]*?[^-])color:[^>]*?;([^<]*?<\/a>)/g, '$1$2') // 移除链接颜色
      .replace(/color: rgb\(51, 51, 51\);/g, '') // 移除默认颜色
      // .replace(/(color: rgba\(\d+, \d+, \d+), \S+\)/g, '$1)') // 移除rgba
      .replace(/(<td[^>]*?)background-color: rgb\(255, 255, 255\);([^<]*?<\/td>)/g, '$1$2') // 处理空白背景单元格
      .replace(/(<td[^<]*?>)(\s*?)(<\/td>)/g, '$1<p></p>$3') // 处理空单元格
      .replace(/(<li[^<]*?>)(\s*?)(<\/li>)/g, '$1<p></p>$3') // 处理空序列
      .replace(/<tr[^>]*?cloneHeader.*?<\/tr>/g, '') // 浏览态克隆的表头行
      .replace(/<tr[^>]*?>[^<]*?(<tr)/g, '$1') // 异常表格行
      .replace(/<col[^>]*?style="width: 0px;"[^<]*?>/g, '<col>') // 自适应表格
      // .replace(/(<[^<]*?>)<br[^<]*?>(<\/)/g, '$1\u200B$2') // 零宽度字符替换非文本br
      .replace(/<img[^>]*? src="file:\/\/\/[^<]*?>/g, '') // 移除本地图片
      .replace(/<img[^>]*? src="https:\/\/file\.sankuai\.com\/pan\/[^<]*?>/g, '<span>\u200b</span>') // 移除大象图片
      .replace(/ct-selected/g, '') // 移除选中状态
      .replace(/(<div class="ct-gantt.*?>).*?(<\/div>)/g, '$1$2') // 去除甘特图内容
      .replace(/(<td[^>]*?>[^<]*?)(<!--EndFragment-->)/g, '$1<p></p></td></tr></tbody></table></div>$2') // 修复浏览态复制表格HTML结构不全
      .replace(/&amp;token=.*?&amp;isNewContent=\w*/g, '') // 去除浏览态复制来的token信息
      .replace(/&amp;isNewContent=\w*/g, ''); // 去除浏览态复制来的isNewContent信息

      return this;
    };

    this.filterShadowDom = html => {
      if (!~this.htmlString.indexOf(index_ts.SHADOWDOM_CLASS)) {
        return this; // 如果没有shadowClass直接返回
      }

      let createSpan = document.createElement('span');
      createSpan.innerHTML = this.htmlString;
      createSpan.querySelectorAll(`.${index_ts.SHADOWDOM_CLASS}`).forEach(el => el.remove());
      this.htmlString = createSpan.innerHTML;
      return this;
    };

    this.washHeadingAttr_ID = () => {
      if (!~this.htmlString.indexOf('ct-heading')) return this;
      let createDom = document.createElement('div');
      createDom.innerHTML = this.htmlString;
      const heading = createDom.querySelectorAll('.ct-heading');
      heading.forEach(h => {
        if (h.getAttribute('id')) h.setAttribute('id', uuid());
      });
      this.htmlString = createDom.innerHTML;
      return this;
    };

    this.washDiffIds = () => {
      let createDom = document.createElement('div');
      createDom.innerHTML = this.htmlString;
      const list = createDom.querySelectorAll('[data-diff-id]');
      list.forEach(h => {
        h.setAttribute('data-diff-id', `ct-diff-id-${uuid()}`);
      });
      this.htmlString = createDom.innerHTML;
      return this;
    };

    this.value = () => this.htmlString;

    this.htmlString = htmlStr;
  }

}

const transformPastedHTML = html => {
  let transformer = new HTMLTransformer(html);
  let res = transformer.parsePMSlice().parseExcel().parseWikiTable().pareseCode().otherFilter().filterShadowDom().washHeadingAttr_ID().washDiffIds().value();
  return res;
};
const transformPasted = (store, slice) => {
  /* eslint-disable camelcase */
  const {
    trigger
  } = store.editor;
  const {
    schema,
    selection
  } = store.view.state;
  const {
    $from
  } = selection;
  const {
    paragraph,
    heading,
    table,
    table_row,
    latex_inline
  } = schema.nodes;
  const sliceContent = slice.content.content;

  if (slice.openStart === slice.openEnd && sliceContent.some(node => node.isBlock && node.type !== heading && node.type !== paragraph)) {
    slice.openStart = 0;
    slice.openEnd = 0;
  } else if (slice.openStart > 1 && slice.openEnd > 1) {
    slice.openStart = 1;
    slice.openEnd = 1;
  }

  if (sliceContent.length !== 1) {
    const sliceMinWidth = index_js.computeSliceMinWidth(slice);
    if (sliceMinWidth) trigger('afterInsert', {
      braceWidth: sliceMinWidth
    });
    return slice;
  }

  let newSlice = slice;
  const sliceNode = sliceContent[0];
  const sliceNodeType = sliceNode.type;
  const foundTableRow = index_js.findParentNode($from.path, node => node.type === table_row); // 块元素前后加空行
  // 表格中粘贴表格的情况由pm默认处理

  if (!(sliceNodeType === table && foundTableRow) && sliceNodeType.spec.insertBlock) {
    newSlice = index_js.getInsertBlockSlice(store.view.state, sliceNode);
    if (newSlice === sliceNode) newSlice = slice;
  }

  if (sliceNodeType === latex_inline) {
    newSlice.openend = 0;
    newSlice.openStart = 0;
  } // 部分内容撑开表格处理


  const braceWidth = sliceNodeType.spec.braceWidth;
  if (braceWidth) trigger('afterInsert', {
    braceWidth
  });
  return newSlice;
};

const specialChar = String.fromCharCode(10); // sublime text3的特殊换行符

function createPlugin(store) {
  const pluginKey = new prosemirrorState.PluginKey('basic');
  return new prosemirrorState.Plugin({
    key: pluginKey,
    props: {
      // 粘贴逻辑
      transformPastedHTML,
      transformPastedText: text => text.replace(new RegExp(specialChar, 'g'), '\n'),
      // 部分编辑器特殊换行符
      // 覆盖原生纯文本处理，防止文本前后空格被移除
      clipboardTextParser: text => {
        const {
          schema
        } = store.view.state;
        const {
          paragraph
        } = schema.nodes;
        const contents = [];
        const len = text.length;
        let cursor = 0;

        while (cursor < len) {
          const breakIndex = text.indexOf('\n', cursor);

          if (breakIndex !== -1) {
            const textContent = text.slice(cursor, breakIndex);
            if (textContent) contents.push(paragraph.create(null, schema.text(textContent)));
            cursor = breakIndex + 1;
          } else {
            contents.push(paragraph.create(null, schema.text(text.slice(cursor, len))));
            cursor = len + 1;
          }
        }

        const fragment = prosemirrorModel.Fragment.from(contents);
        const slice = new prosemirrorModel.Slice(fragment, 1, 1);
        return slice;
      },
      transformPasted: slice => transformPasted(store, slice),
      transformDroped: slice => transformPasted(store, slice)
    }
  });
}

class BasicStore {
  constructor() {
    this.view = null;
    this.editor = null;
  }

  init(editor) {
    this.view = editor.view;
    this.editor = editor;
  }

}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".ProseMirror{position:relative;outline:none;word-wrap:break-word;white-space:pre-wrap;-webkit-font-variant-ligatures:none;font-variant-ligatures:none}.ProseMirror *{box-sizing:border-box}.ProseMirror-hideselection ::selection{color:#666}.ProseMirror-hideselection ::-moz-selection{color:#666}.ProseMirror [draggable]{-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text}.ProseMirror pre{white-space:pre-wrap}.ProseMirror-hideselection ::selection{background:transparent}.ProseMirror-hideselection ::-moz-selection{background:transparent}.ProseMirror-hideselection{caret-color:transparent}.ProseMirror-selectednode{outline:none}.ProseMirror-hideselection ::-moz-selection{color:inherit!important}.ProseMirror-hideselection ::selection{color:inherit!important}.ct-editor h1,.ct-editor h2,.ct-editor h3,.ct-editor h4,.ct-editor h5,.ct-editor h6,.ct-editor p,.ct-editor pre,.pm-body-wrapper h1,.pm-body-wrapper h2,.pm-body-wrapper h3,.pm-body-wrapper h4,.pm-body-wrapper h5,.pm-body-wrapper h6,.pm-body-wrapper p,.pm-body-wrapper pre,.ProseMirror h1,.ProseMirror h2,.ProseMirror h3,.ProseMirror h4,.ProseMirror h5,.ProseMirror h6,.ProseMirror p,.ProseMirror pre{margin:8px 0;color:#333;word-break:break-word;clear:both}.ct-editor p,.ct-editor pre,.pm-body-wrapper p,.pm-body-wrapper pre,.ProseMirror p,.ProseMirror pre{font-size:14px;line-height:22px;min-height:24px}.ct-editor h1,.ct-editor h2,.ct-editor h3,.ct-editor h4,.pm-body-wrapper h1,.pm-body-wrapper h2,.pm-body-wrapper h3,.pm-body-wrapper h4,.ProseMirror h1,.ProseMirror h2,.ProseMirror h3,.ProseMirror h4{padding:8px 0}.ct-editor h5,.ct-editor h6,.pm-body-wrapper h5,.pm-body-wrapper h6,.ProseMirror h5,.ProseMirror h6{padding:4px 0}.ct-editor h1,.pm-body-wrapper h1,.ProseMirror h1{font-size:28px;font-weight:700;line-height:36px;min-height:36px}.ct-editor h2,.pm-body-wrapper h2,.ProseMirror h2{font-size:24px;font-weight:700;line-height:32px;min-height:32px}.ct-editor h3,.pm-body-wrapper h3,.ProseMirror h3{font-size:20px;font-weight:700;line-height:28px;min-height:28px}.ct-editor h4,.pm-body-wrapper h4,.ProseMirror h4{font-size:16px;font-weight:700;line-height:24px;min-height:24px}.ct-editor h5,.pm-body-wrapper h5,.ProseMirror h5{font-size:14px;font-weight:700;line-height:22px;min-height:22px}.ct-editor h6,.pm-body-wrapper h6,.ProseMirror h6{font-size:12px;font-weight:700;line-height:20px;min-height:20px}.ct-editor hr,.pm-body-wrapper hr,.ProseMirror hr{display:block;height:1px;width:100%;border:0;background:#ccc}.ct-editor hr.ProseMirror-selectednode,.pm-body-wrapper hr.ProseMirror-selectednode,.ProseMirror hr.ProseMirror-selectednode{background:#00a7cd}";
styleInject(css);

class BasicModule {
  constructor() {
    this.name = 'basic';
    this.store = new BasicStore();
    this.schema = {
      nodes,
      marks
    };
    this.commands = {
      clearFormat,
      insertHr,
      setIndent,
      setTextBlockType,
      setAlign,
      setTextColor,
      setTextDefaultColor,
      toggleMark,
      toggleSuMark,
      setFontsize
    };
    this.utils = {
      canAlign,
      canIndent,
      getAttrs,
      getTextBlockType,
      hasMark,
      isTextBlock,
      isWeirdBlock,
      isAlignedBlock,
      getTextFontsize,
      canSetFontsize,
      isInParagraph,
      isInHeading
    };
    this.plugins = [keymap({
      Enter: handleEnter,
      'Shift-Enter': handleShiftEnter,
      Backspace: handleBackspace,
      'Mod-Backspace': handleBackspace,
      Delete: handleDelete,
      'Mod-Delete': handleDelete
    }), keymap(prosemirrorCommands.baseKeymap), keymap({
      Tab: TabKeymap(false, this.store),
      'Shift-Tab': TabKeymap(true, this.store)
    }), createPlugin(this.store)];
  }

  init(editor) {
    this.store.init(editor);
  }

}
BasicModule.moduleName = 'basic';

exports.BasicModule = BasicModule;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/@mtfe/citadel-editor/lib/basic/index.js